(() => {
  if (customElements.get('fp-cart-games')) return;
  let busy = false;
  let needsRefresh = false;
  const disabledControls = new Map();
  const controlSelector = 'cart-items quantity-input input, cart-items quantity-input button, cart-drawer-items quantity-input input, cart-drawer-items quantity-input button, product-form button[type="submit"], fp-cart-games button[type="submit"], fp-cart-games select';
  const setBusy = value => {
    busy = value;
    document.documentElement.classList.toggle('fp-cart-games-busy', value);
    if (value) {
      document.querySelectorAll(controlSelector).forEach(control => { disabledControls.set(control, control.disabled); control.disabled = true; });
    } else {
      disabledControls.forEach((wasDisabled, control) => { if (control.isConnected) control.disabled = wasDisabled; });
      disabledControls.clear();
    }
  };
  document.addEventListener('click', event => {
    if (busy && event.target.closest('cart-remove-button')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  function sectionPlan() {
    const drawer = document.querySelector('cart-drawer');
    const main = document.getElementById('main-cart');
    const plan = [];
    if (main?.dataset.id) plan.push({id:main.dataset.id, selector:'#main-cart', required:true});
    if (drawer) plan.push({id:'cart-drawer', selector:'#CartDrawer', required:true});
    ['header','mobile-header'].forEach(id=>{const selector='#cart-icon-bubble-'+id;if(document.querySelector(selector))plan.push({id,selector,required:false});});
    const native = drawer?.getSectionsToRender?.() || [];
    native.forEach(item => {
      if (item.id !== 'cart-drawer' && item.selector && document.querySelector(item.selector)) plan.push({id:item.id, selector:item.selector, required:false});
    });
    return plan.filter((item,index) => plan.findIndex(other => other.id === item.id) === index).slice(0,5);
  }
  function validSections(sections, plan) {
    return sections && plan.every(item=>{
      if (typeof sections[item.id] !== 'string') return false;
      return !!new DOMParser().parseFromString(sections[item.id], 'text/html').querySelector(item.selector);
    });
  }
  async function readSections(plan) {
    const url = new URL(location.pathname, location.origin);
    url.searchParams.set('sections', plan.map(item=>item.id).join(','));
    const response = await fetch(url.pathname+url.search,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Section refresh failed');
    const sections = await response.json();
    if (!validSections(sections,plan)) throw new Error('Incomplete section refresh');
    return sections;
  }
  function applySections(sections, plan) {
    plan.forEach(item=>{
      if (typeof sections[item.id] !== 'string') return;
      const source = new DOMParser().parseFromString(sections[item.id], 'text/html').querySelector(item.selector);
      if (!source) return;
      document.querySelectorAll(item.selector).forEach(target=>{target.innerHTML=source.innerHTML;});
    });
    document.querySelector('cart-drawer')?.classList.remove('is-empty');
  }
  class CartGames extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('submit',this.onSubmit);
      this.addEventListener('change',this.onVariant);
      this.addEventListener('click',this.onArrow);
    }
    disconnectedCallback() {
      this.removeEventListener('submit',this.onSubmit);
      this.removeEventListener('change',this.onVariant);
      this.removeEventListener('click',this.onArrow);
      this.ready = false;
    }
    onArrow = event => {
      const button = event.target.closest('[data-cart-games-direction]');
      if (!button || !this.contains(button)) return;
      const rail = this.querySelector('.fp-cart-games__rail');
      rail.scrollBy({left:Number(button.dataset.cartGamesDirection)*Math.max(140,rail.clientWidth*.75),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    };
    onVariant = event => {
      if (!event.target.matches('[data-cart-game-variant]')) return;
      event.stopPropagation();
      const price = event.target.selectedOptions[0]?.dataset.price;
      if (price) event.target.closest('[data-cart-game]').querySelector('[data-cart-game-price]').textContent=price;
    };
    report(message, recover=false) {
      const status=this.querySelector('[data-cart-games-status]');
      if(status)status.textContent=message;
      const link=this.querySelector('.fp-cart-games__recover');
      if(link)link.hidden=!recover;
    }
    onSubmit = async event => {
      const form=event.target.closest('[data-cart-game-form]');
      if (!form || !this.contains(form)) return;
      event.preventDefault();
      if (needsRefresh) {this.report(this.dataset.uncertain,true);return;}
      if (busy || [...document.querySelectorAll('cart-items,cart-drawer-items')].some(item=>item.waxyQuantityUpdating) || document.querySelector('.cart-item .loading-overlay__spinner:not(.hidden)')) {this.report(this.dataset.busy);return;}
      if (!form.reportValidity()) return;
      const variant=form.elements.id.value;
      if (!/^\d+$/.test(variant)) return;
      const plan=sectionPlan();
      if(!plan.length){form.submit();return;}
      const context=this.dataset.context;
      const cardIndex=[...this.querySelectorAll('[data-cart-game]')].indexOf(form.closest('[data-cart-game]'));
      const railLeft=this.querySelector('.fp-cart-games__rail').scrollLeft;
      const drawer=document.querySelector('cart-drawer');
      const wasOpen=drawer?.classList.contains('active');
      const drawerTop=drawer?.querySelector('.scroll-area')?.scrollTop||0;
      const addedText=this.dataset.added.replace('__game__',form.dataset.gameName);
      const uncertainText=this.dataset.uncertain;
      const label=form.querySelector('[data-cart-game-label]');
      const oldLabel=label?.textContent;
      if(label)label.textContent=this.dataset.adding;
      this.report(this.dataset.adding);
      setBusy(true);
      let rejected=false;
      try {
        const root=window.Shopify?.routes?.root||'/';
        const url=root.replace(/\/?$/,'/')+'cart/add.js';
        const response=await fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variant,quantity:1}],sections:plan.map(item=>item.id),sections_url:location.pathname})});
        const data=await response.json();
        if(!response.ok||data.status){rejected=true;this.report(typeof data.description==='string'?data.description:this.dataset.error);return;}
        const sections=validSections(data.sections,plan)?data.sections:await readSections(plan);
        applySections(sections,plan);
        const fresh=document.querySelector('fp-cart-games[data-context="'+context+'"]');
        if(fresh){
          fresh.report(addedText);
          const rail=fresh.querySelector('.fp-cart-games__rail');
          rail.scrollLeft=railLeft;
          const cards=fresh.querySelectorAll('[data-cart-game]');
          const next=cards[Math.min(Math.max(0,cardIndex),cards.length-1)];
          const focus=next?.querySelector('select,button[type="submit"]')||next?.querySelector('a')||fresh.querySelector('h3');
          if(wasOpen&&context==='drawer'&&typeof trapFocus==='function')trapFocus(drawer.querySelector('.drawer__inner'),focus);
          else focus?.focus({preventScroll:true});
        } else {
          const fallback=context==='drawer'?drawer?.querySelector('.drawer__heading'):document.getElementById('main-cart');
          fallback?.setAttribute('tabindex','-1');fallback?.focus({preventScroll:true});
        }
        const live=document.getElementById('cart-live-region-text')||document.getElementById('CartDrawer-LineItemStatus');
        if(live){live.textContent=addedText;live.setAttribute('aria-hidden','false');}
        if(wasOpen){const scroll=drawer?.querySelector('.scroll-area');if(scroll)scroll.scrollTop=drawerTop;}
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items'});
      } catch (_) {
        if(!rejected){needsRefresh=true;const root=document.querySelector('fp-cart-games[data-context="'+context+'"]')||this;root.report(uncertainText,true);}
      } finally {
        setBusy(false);
        if(label?.isConnected)label.textContent=oldLabel;
        if(needsRefresh)document.querySelectorAll('fp-cart-games [data-cart-game-add]').forEach(button=>{button.disabled=true;});
      }
    };
  }
  customElements.define('fp-cart-games',CartGames);
})();
